export default __webpack_public_path__ + "static/media/local-help-icon.d9b938b3.svg";